import {
    FETCH_ASSESSMENTS_REQUEST,
    FETCH_ASSESSMENTS_SUCCESS,
    FETCH_ASSESSMENTS_FAILURE,

    CREATE_ASSESSMENT_REQUEST,
    CREATE_ASSESSMENT_SUCCESS,
    CREATE_ASSESSMENT_FAILURE,

    UPDATE_ASSESSMENT_REQUEST,
    UPDATE_ASSESSMENT_SUCCESS,
    UPDATE_ASSESSMENT_FAILURE,

    DELETE_ASSESSMENT_REQUEST,
    DELETE_ASSESSMENT_SUCCESS,
    DELETE_ASSESSMENT_FAILURE,
} from "../actions/types";


const initialState = {

    assessments: [],

    loading: false,

    error: null,

    message: "",

};


const assessmentReducer = (
    state = initialState,
    action
) => {

    switch (action.type) {



        case FETCH_ASSESSMENTS_REQUEST:

            return {
                ...state,

                loading: true,

                error: null,
            };


        case FETCH_ASSESSMENTS_SUCCESS:

            return {

                ...state,

                loading: false,

                assessments:
                    Array.isArray(
                        action.payload
                    )
                        ? action.payload
                        : [],

                message:
                    "Assessments loaded successfully",
            };


        case FETCH_ASSESSMENTS_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,

                assessments: [],
            };



        case CREATE_ASSESSMENT_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,
            };


        case CREATE_ASSESSMENT_SUCCESS:

            return {

                ...state,

                loading: false,

                assessments: [
                    ...state.assessments,
                    action.payload,
                ],

                message:
                    "Assessment created successfully",
            };


        case CREATE_ASSESSMENT_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,
            };



        case UPDATE_ASSESSMENT_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,
            };


        case UPDATE_ASSESSMENT_SUCCESS:

            return {

                ...state,

                loading: false,

                assessments:
                    state.assessments.map(
                        (assessment) =>
                            assessment.assessment_id ===
                            action.payload.assessment_id
                                ? {
                                    ...assessment,
                                    ...action.payload,
                                }
                                : assessment
                    ),

                message:
                    "Assessment updated successfully",
            };


        case UPDATE_ASSESSMENT_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,
            };


        case DELETE_ASSESSMENT_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,
            };


        case DELETE_ASSESSMENT_SUCCESS:

            return {

                ...state,

                loading: false,

                assessments:
                    state.assessments.filter(
                        (assessment) =>
                            assessment.assessment_id !==
                            action.payload
                    ),

                message:
                    "Assessment deleted successfully",
            };


        case DELETE_ASSESSMENT_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,
            };


        default:

            return state;

    }

};


export default assessmentReducer;